
<div class="v-flex">
    <v-menu
        :close-on-content-click="false"
        bottom
        offset-y
        nudge-bottom="5"
    >
        <template v-slot:activator="{ on, attrs }">
            <a
                v-bind="attrs"
                v-on="on"
            >
                <v-icon class="nav-icon toolbar-button" :class="filter ? 'primary--text' : 'red--text'">{{ filter ? 'mdi-filter' : 'mdi-filter-outline' }} </v-icon>
            </a>
        </template>

        <div class="white pa-2 pb-3">
            <v-row dense>
                <v-col class="v-flex">
                    <v-checkbox
                        v-if="filter"
                        v-model = "filter.onlyLiftmanagement"
                        class   = "mt-0"
                        :ripple = "false"
                        @click  = "onChange"
                        hide-details
                    >
                        <template v-slot:label>
                            <span style="width: 30px; margin-top: 1px;color: gray" >LM</span> <span class="filter-label">Nur Liftmanagement</span>
                        </template>
                    </v-checkbox>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col class="v-flex">
                    <v-checkbox
                        v-if="filter"
                        v-model = "filter.onlyMyCustomers"
                        class   = "mt-0"
                        :ripple = "false"
                        @click  = "onChange"
                        hide-details
                    >
                        <template v-slot:label>
                            <span class="filter-label"><v-icon size="20" style="width: 30px">mdi-account-multiple</v-icon>Anlagen meiner Kunden</span>
                        </template>
                    </v-checkbox>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col class="v-flex">
                    <v-checkbox
                        v-if="filter"
                        v-model = "filter.onlyIdleUnits"
                        class   = "mt-0"
                        :ripple = "false"
                        @click  = "onChange"
                        hide-details
                    >
                        <template v-slot:label>
                            <span class="filter-label"><v-icon size="20" style="width: 30px">mdi-flash</v-icon>Anlagen im Stillstand</span>
                        </template>
                    </v-checkbox>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col class="v-flex">
                    <v-checkbox
                        v-if="filter"
                        v-model = "filter.onlyLgSmartDevices"
                        class   = "mt-0"
                        :ripple = "false"
                        @click  = "onChange"
                        hide-details
                    >
                        <template v-slot:label>
                            <span class="filter-label"><v-icon size="20" style="width: 30px; margin-top: -2px">mdi-router-wireless</v-icon>Liftguardian Anlagen</span>
                        </template>
                    </v-checkbox>
                </v-col>
            </v-row>
        </div>
    </v-menu>
    <div v-if="changed">
        <c-toolbar-button
            icon="mdi-filter-off"
            color="primary"
            size="24"
            @click = "onClear"
        />
    </div>
    <div class="v-flex lm-border ml-1" style="width: 130px;" v-if="filter">
        <div v-if="filter.onlyLiftmanagement" class="pl-2" style="font-size: 15px; margin-top: 5px;">
            LM
        </div>
        <div v-if="filter.onlyMyCustomers" class="pl-2">
            <v-icon size="22">mdi-account-multiple</v-icon>
        </div>
        <div v-if="!filter.onlyMyCustomers" class="pl-2">
            <v-icon size="22" color="primary">mdi-all-inclusive</v-icon>
        </div>
        <div v-if="filter.onlyIdleUnits" class="pl-2" style="margin-top: 1px;">
            <v-icon size="22">mdi-flash</v-icon>
        </div>
        <div v-if="filter.onlyLgSmartDevices" class="pl-2">
            <v-icon size="22">mdi-router-wireless</v-icon>
        </div>
    </div>

</div>
